import { Injectable, ElementRef, ViewChild } from '@angular/core';
import * as jsPDF from 'jspdf';
import * as html2canvas from 'html2canvas';
import { TeammemberDashboardComponent } from '../../features/dashboard/components/teammember/teammember-dashboard.component';

@Injectable()
export class PrintPDFService {

  @ViewChild('PrintToPDF') printingElement: ElementRef;

  constructor() { }

  generatePDF() {

    const doc = new jsPDF('p', 'pt', 'a4', 1);
    // const options = {
    //   pagesplit: true
    // };
    // doc.fromHTML(this.printingElement.nativeElement.value, 70, 69);



    // const pdf = new jsPDF();
    // pdf.addHTML(elementToPrint, () => {
    //   pdf.save('test.pdf');
    // });


    // doc.save('Test.pdf');
    // );
    // doc.addHTML(this.printingElement.nativeElement, 0, 0, options, () => {
    // doc.save('test.pdf');
    // });

    const elementToPrint = document.getElementById('PrintToPDF');

    html2canvas(elementToPrint).then(function (canvas) {
      const img = canvas.toDataURL(
        'jpeg',
        {
          quality: 0.9
        });

      doc.addImage(img, 'JPEG', 100, 100);
      doc.save('test.pdf');
    });
    // doc.save('test.pdf');//fails to add image to pdf
  }

  download() {

    html2canvas(document.getElementById('PrintToPDF')).then(

      canvas => {

        const doc = new jsPDF('p', 'pt', 'a4', 1);

        // add the image with some compression to reduce the file size
        const img = canvas.toDataURL('image/png', 0.99);

        doc.addImage(img, 'JPEG', 20, 20);
        doc.save('test.pdf');

      },
      error => console.log(error)
    );

  }

  print2PDF(elementID: string, filename: string = 'FocusCRM', optionalLeft = 10, optionalTop = 20) {

    // Set the optional args to the default
    // if (typeof optionalLeft === 'undefined') { optionalLeft = 10; }
    // if (typeof optionalTop === 'undefined') { optionalTop = 30; }

    const target = document.getElementById(elementID);

    // used to adjust the widths / heights
    const oldWidth = target.offsetWidth;
    const oldHeight = target.offsetHeight;

    const newWidth = oldWidth * (1 / 3.7);
    const newHeight = oldHeight * (1 / 3.7);

    const canvasWidth = oldWidth * 2;
    const canvasHeight = oldHeight * 2;

    // Generate a canvas element from the HTML div.
    html2canvas(target, { logging: true, background: '#FFFFFF', letterRendering: true, width: canvasWidth, height: canvasHeight }).then(function (canvas) {

      // Next, transform the canvas element into an image.
      const imgData = canvas.toDataURL('image/jpeg', 0.9);
      // console.log(imgData);

      const actualHeight = (newHeight + optionalTop + 10) < 297 ? 297 : newHeight + optionalTop + 10;

      // THEN create as a PDF
      const doc = new jsPDF('p', 'mm', 'a4', 0.9); // [ 210 , actualHeight]);

      // doc.addImage(logoData, 'JPEG', 120, 15, 80, 14);
      doc.addImage(imgData, 'JPEG', optionalLeft, optionalTop, newWidth, newHeight);

      // save it
      doc.save(filename + '.pdf');

    });

  }


}



// WEBPACK FOOTER //
// ./client/app/shared/print-pdf/print-pdf.service.ts